export default __webpack_public_path__ + "static/media/p3img1-m.67beeeb2.png";